




























import { defineComponent, PropType } from '@vue/composition-api'
import { NotificationItemType } from '@/components/NotificationPane/NotificationPane.vue'
import BaseNotificationItemContentsParts from '@/components/NotificationPane/NotificationPane/parts/BaseNotificationItemContentsParts.vue'

/**
 * Notification 詳細アイテム: TYPE = 通知 コンポーネント
 */
export default defineComponent({
  name: 'NotificationItemContentsParts',
  components: {
    BaseNotificationItemContentsParts,
  },
  props: {
    notification: {
      type: Object as PropType<NotificationItemType>,
      required: true,
    },
  },
})
